/** @format */

import React from 'react';
import { Grid, IconButton, Typography, Card, CardContent } from '@mui/material';
import NumberFormat from 'react-number-format';
import { ConfirmDialog, Icons, PriceLabel } from 'components';
import jMoment from 'moment-jalaali';
import { useStyles } from './style';
import createToast from 'components/Toast/Toast';
import clsx from 'clsx';
import Services from '../../services/WithdrawRuleServices';
import useCustomHook from './hooks';
import {useCurrencyUnit } from 'hooks'

export default function Key({ data, wallets = [], refreshList }) {
  // --STATES--//

  const { isLoading, setIsLoading, openDialog, setOpenDialog } = useCustomHook();
  // --HOOKS--//

  const classes = useStyles();
  const currencyText = useCurrencyUnit(false);

  // --API--//

  const deleteGrant = async () => {
    if (!data?.id) return;
    try {
      setIsLoading(true);
      await Services.deleteWithdrawRule(data.id);
      setIsLoading(false);
      createToast('موفق', 'مجوز با موفقیت حذف شد', 'success');
      setOpenDialog(false);
      refreshList();
    } catch (err) {
      setIsLoading(false);
    }
  };

  // -- LOCAL VARIABLES --//

  // -- OTHER FUNCTIONS--//
  const getWalletName = () => {
    if (!wallets) return;
    const fWallet = wallets?.find((v) => v?.wallet === data?.wallet);
    return fWallet?.walletName ?? '';
  };

  return (
    <Card
      xs={12}
      className={clsx(classes.root, {
        active: !data?.expired && data?.active,
      })}
    >
      <CardContent className={classes.content}>
        <Grid container justifyContent="space-between" alignItems="flex-start">
          <Grid item className={classes.titlePart}>
            <Typography variant="h5" className={classes.titleText}>
              {data?.business?.name ?? '-'}
            </Typography>
            <Typography variant="h6" className={classes.subtitleText}>
              شناسه کسب‌وکار: {data?.business?.id ?? '-'}
            </Typography>
          </Grid>
          {!data?.expired && data?.active ? (
            <Grid item className={classes.titleActions}>
              <IconButton
                className={classes.actionsIcon}
                onClick={() => setOpenDialog(true)}
                size="large">
                 <Icons icon="Trash" color="#2b3990" size="20" />
              </IconButton>
            </Grid>
          ) : (
            <Grid item className={classes.expiredFlag}>
              {data?.expired ? 'منقضی شده' : !data?.active ? 'غیرفعال' : ''}
            </Grid>
          )}
        </Grid>

        {/* Balances */}
        <Grid container justifyContent="space-between">
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>حساب دیجیتال</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.wallet ? getWalletName() : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>وضعیت مجوز</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.active && !data?.expired
                ? 'فعال'
                : `غیرفعال - ${data?.expired ? 'منقضی شده' : 'منقضی نشده'}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>تاریخ ایجاد</Typography>
            <Typography className={classes.balanceMoney}>
              {data && data?.creationDate
                ? jMoment(data?.creationDate).format('jYYYY/jMM/jDD')
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>تاریخ انقضا</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.expireDate
                ? jMoment(data?.expireDate).format('jYYYY/jMM/jDD')
                : '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>سقف مجموع قابل برداشت</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.maxAmount ? (
                <>
                  <PriceLabel amount={data?.maxAmount} currency={currencyText} />
                </>
              ) : (
                '-'
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>مجموع برداشت شده تا کنون</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.usageAmount ? (
                <>
                   <PriceLabel amount={data?.usageAmount} currency={currencyText} />
                </>
              ) : (
                '-'
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>تعداد دفعات مجاز برداشت</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.maxCount ? (
                <NumberFormat
                  value={data?.maxCount}
                  displayType="text"
                  thousandSeparator
                  renderText={(p) => p}
                />
              ) : (
                '-'
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={classes.balanceTitle}>دفعات برداشت تا کنون</Typography>
            <Typography className={classes.balanceMoney}>
              {data?.usageCount ? (
                <NumberFormat
                  value={data?.usageCount}
                  displayType="text"
                  thousandSeparator
                  renderText={(p) => p}
                />
              ) : (
                '-'
              )}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <ConfirmDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={deleteGrant}
        title="تایید حذف مجوز برداشت"
        confirmButtonText="تایید و حذف مجوز"
        cancelButtonProps="انصراف"
        loading={isLoading}
        confirmButtonProps={{ type: 'submit' }}
      >
        آیااز حذف مجوز برداشت اعطا شده به کسب‌وکار زیر اطمینان دارید؟
        <Typography style={{ marginTop: 10 }}>
          <b>{data?.business?.name ?? '-'}</b>
        </Typography>
        <Typography>
          شناسه کسب‌وکار: <b>{data?.business?.id ?? '-'}</b>
        </Typography>
      </ConfirmDialog>
    </Card>
  );
}
